import React from 'react';

// TODO: move this to EDS
const PressButtonBlueSVG = () => (
    <svg
        version="1.1"
        id="press-button-blue"
        x="0px"
        y="0px"
        viewBox="0 0 232 320"
        style={{ enableBackground: 'new 0 0 232 320' }}
    >
        <rect fill="#F8F7FA" width="232" height="320" />
        <path fill="#DBDAE3" d="M0,17.4v285.3C236.9,254.1,168,22.5,0,17.4z" />
        <path
            fill="#D84430"
            d="M59.3,242.9c0.5-6.3,3.8-11.2,3.8-11.2s-8.3-6.7-14-12.7c-1.4,0.5-2.7,1.1-2.4,2.4c0.2,1.1,1.4,8,2.6,14.3
            c3.2,2,7.7,8.8,8.9,10.7l1.7-1.6L59.3,242.9z"
        />
        <path
            fill="#F05537"
            d="M58.4,258.4c2.5-0.8,2.7-1.1,3.9-2.5c2.8-3.7,5.3-8.4,7.4-12.7c1-2.1,1.9-4.2,2.7-5.9c1.7-3.9,2.6-6.6,2.7-6.7
            c0.2-0.4,0.5-0.5,0.9-0.5c0.4,0.2,0.5,0.5,0.5,0.9c-0.2,0.4-1.1,3.3-2.8,7.3c-0.2,0.5-0.5,1-0.7,1.6c-2,4.6-4.7,9.9-7.8,14.5
            c2.9,0.8,6.9,1.5,8.8-0.6c0.3-0.4,0.7-0.7,1-1.1c0.1-0.2,0.2-0.2,0.4-0.3c2.5-3,5-6.1,7.1-9.3c0.4-0.5,0.7-1,1.1-1.5
            c5.2-7.5,8.7-14,8.8-14c0.2-0.4,0.6-0.5,0.9-0.3s0.5,0.6,0.3,0.9c-0.1,0.1-5.8,10.5-13.4,20.4c-0.3,0.4-0.6,0.8-0.9,1.1
            c-0.7,0.9-1.4,1.7-2.2,2.7c0.3,0.2,0.5,0.2,0.8,0.2c0.1,0.1,0.2,0.1,0.3,0.1c4.5,1.2,7.4,2,9.7,1c1.3-0.5,2.4-1.5,3.6-3.2
            c6.2-9.2,8.6-12.8,11.8-19.4l3,2.4c0,0,7.4,8.3,10.1,12.1c0.2,0.3,0.3,0.5,0.5,0.7c0,0,0.1,0.1,0.1,0.2c0.2,0.2,0.2,0.5,0.4,0.6
            c1.1,2.1,1.7,4.9,1.9,8.1c0.4,3.3,0.5,7.1,0.7,10.5c0,0.2,0,0.5,0,0.7c0,0.2,0,0.5,0,0.7c0.1,0.8,0.2,1.5,0.2,2.3
            c0.1,0.9,0.2,1.8,0.4,2.7c0,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.6c0.8,3.6,2.4,6,5.4,6.2c2,0.2,3.2-3.7,3.7-9.1
            c0.1-0.1,0-0.2,0.1-0.4c0.1-0.1,0-0.2,0.1-0.4c0-0.5,0.1-1.1,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6l0,0c0.1-0.1,0-0.2,0.1-0.3
            c0-0.5,0.1-1.1,0.1-1.6c0-1.2,0.1-2.4,0.1-3.6c0-0.7,0-1.4,0-2.1c0-1.9,0-3.7,0-5.5c-0.1-2.9-0.2-5.5-0.4-7.6
            c-0.2-2.2-0.5-4-0.5-4.9c-0.3-1.6-2.4-4.9-4.9-8.7c-0.2-0.2-0.3-0.5-0.5-0.7c-0.2-0.2-0.3-0.5-0.5-0.7c-5-7.1-11.5-14.9-11.5-14.9
            s-1.4-1.9-3.6-4.7c-1.7-2.1-3.8-4.9-6.4-8c-0.1-0.1-0.2-0.2-0.2-0.2c-5-5.9-11.3-12.8-17.9-18.4c-0.4-0.3-0.8-0.6-1.1-1
            c-8.3-6.8-15.6-15-20.4-21.2c-4.2-5.2-6.8-9.1-6.8-9.1l-0.2-0.4l-0.1-0.2c-1.7,0.1-7.7,0.5-15.4,2.4c-6.8,1.7-14.9,4.7-22.4,9.9
            l0.9,2l2.4,5.2c0,0-0.6,11.2,1.4,17.2c0.4,1.1,0.8,2,1.4,2.7c1.1,1.4,5.2,5.7,10.1,10.9c2,2.2,4.3,4.7,6.7,7.1
            c2.7,2.9,5.3,5.5,7.7,8.2c5.8,6,10.1,10.7,10.1,10.7s-1.4,6-1.9,12.3c-0.1,0.3-0.1,0.6-0.1,1.1s-0.1,0.8-0.1,1.3
            c0,0-0.1-0.2-0.2-0.5c-0.2-0.3-0.1-0.2-0.3-0.5c-1.2-1.9-4.2-6.5-7.4-8.5c-1.9-1.2-3.9-1.5-5.5,0.2c-1.2,1.2,0.8,6.1,3.6,11.3
            c1.4,2.4,3,4.9,4.6,6.9C53.8,256.3,56.7,258.9,58.4,258.4z"
        />
        <path
            fill="#F05537"
            d="M103.7,307.6c0-10,9.6-18.1,21.4-18.1s21.4,8.1,21.4,18.1"
        />
        <rect x="87.3" y="302.9" fill="#1E0A3C" width="75.7" height="17" />
        <rect
            x="140.4"
            y="282.7"
            transform="matrix(0.6052 -0.7961 0.7961 0.6052 -168.7299 225.7671)"
            fill="#1E0A3C"
            width="5.8"
            height="0.7"
        />
        <rect
            x="136.1"
            y="280.7"
            transform="matrix(0.2039 -0.979 0.979 0.2039 -164.8274 359.3774)"
            fill="#1E0A3C"
            width="5"
            height="0.7"
        />
        <rect
            x="143.9"
            y="286.7"
            transform="matrix(0.89 -0.4559 0.4559 0.89 -114.7643 98.3305)"
            fill="#1E0A3C"
            width="5"
            height="0.7"
        />
        <rect y="1.3" fill="none" width="205.6" height="318.7" />
        <path
            fill="#324B8C"
            d="M0,26.6V150l15.2,19.6c1.5-1.3,3.1-2.4,4.6-3.5c7.6-5.1,15.6-8.2,22.4-9.9c7.7-2,13.7-2.4,15.4-2.4h0.5L0,26.6z"
        />
    </svg>
);

export default PressButtonBlueSVG;
